import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { kebabCase } from 'lodash';
import Indentation from './indentation';
import TreeNodeText from './treeNodeText';
import ExpandCollapse from './expandCollapse';
import EmptyIcon from './emptyIcon';
import MoveIcon from './moveIcon';
import Target from './target';
const options = {
  onhoverColor: '#F5F5F5',
  selectedColor: '#FFFFFF',
  selectedBackColor: '#428bca'
};
class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.clickDocument = this.clickDocument.bind(this);
  }
  componentDidMount() {
    // need to monitor clicks to see if they are outside of this component.
    // if so and this component is selected, we will de-select it.
    global.document.addEventListener('click', this.clickDocument);
  }
  componentWillUnmount() {
    global.document.removeEventListener('click', this.clickDocument);
  }
  setStyle() {
    let style;
    const {
      node,
      isDragging,
      highlightSelected
    } = this.props;
    const {
      hover
    } = this.state;
    if (highlightSelected && this.isSelected()) {
      style = {
        color: options.selectedColor,
        backgroundColor: options.selectedBackColor
      };
    } else {
      style = {
        color: node.color,
        backgroundColor: node.backColor
      };
    }
    if (hover) {
      style.backgroundColor = '#f5f5f5';
      style.cursor = 'pointer';
    }
    style.paddingRight = '10px';
    style.paddingLeft = '10px';
    if (isDragging) {
      style.opacity = 0.2;
      style.backgroundColor = 'transparent';
    }
    return style;
  }
  handleAdd() {
    const {
      expanded,
      toggleExpanded,
      onAdd,
      node
    } = this.props;
    if (!expanded) {
      toggleExpanded();
    }
    onAdd(node.id, this);
  }
  handleClick(event) {
    const {
      selectNode
    } = this.props;
    event.stopPropagation();
    // get rid of any selected nodes...hold off for now - cant click buttons!!
    if (!this.isSelected()) {
      selectNode(null);
    }
  }
  isSelected() {
    const {
      selectedId,
      node
    } = this.props;
    return selectedId === node.id;
  }
  clickDocument(event) {
    const {
      selectNode
    } = this.props;
    const {
      hover
    } = this.state;
    event.stopPropagation();
    if (this.isSelected() && !hover) {
      selectNode(null);
    }
  }
  handleHover(isHovering) {
    this.setState({
      hover: isHovering
    });
  }

  /* eslint-disable react/no-unused-class-component-methods */
  hasTarget() {
    const {
      target,
      node
    } = this.props;
    return !_.isNull(target) && (target.id === 'dummy' && target.parentID === node.id || node.nodes.some(currentNode => currentNode.id === target.id));
  }
  render() {
    const {
      node,
      index,
      lastSelector,
      level,
      target,
      toggleExpanded,
      expanded,
      selectedId,
      selectNode,
      onSave,
      onRemove,
      enableLinks,
      children
    } = this.props;
    const {
      hover
    } = this.state;
    const style = this.setStyle();
    const className = `tree-node t-tn-tree-node t-tn-index-${index} ${lastSelector} t-tn-${kebabCase(node.name)} t-tn-level-${level}`;
    return /*#__PURE__*/React.createElement("div", {
      key: node.nodeId
    }, /*#__PURE__*/React.createElement("div", {
      onKeyDown: this.handleClick,
      role: "link",
      tabIndex: 0,
      style: style,
      className: className,
      onClick: this.handleClick,
      onMouseEnter: this.handleHoverTrue,
      onMouseLeave: this.handleHoverFalse
    }, !_.isNull(target) && target.id === node.id ? /*#__PURE__*/React.createElement(Target, {
      level: level
    }) : null, /*#__PURE__*/React.createElement(Indentation, {
      level: level
    }), node.nodes && node.nodes.length ? /*#__PURE__*/React.createElement(ExpandCollapse, {
      onClick: toggleExpanded,
      expanded: expanded
    }) : /*#__PURE__*/React.createElement(EmptyIcon, null), /*#__PURE__*/React.createElement(TreeNodeText, {
      selected: selectedId === node.id,
      hover: hover,
      onSelect: selectNode,
      onHover: this.handleHover,
      onSave: onSave,
      onAdd: this.handleAdd,
      onRemove: onRemove,
      enableLinks: enableLinks,
      node: node
    }), /*#__PURE__*/React.createElement(MoveIcon, null)), children);
  }
}
TreeNode.defaultProps = {
  enableLinks: false,
  highlightSelected: false,
  index: 0,
  selectedId: null,
  target: null,
  children: []
};
TreeNode.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  children: PropTypes.shape({}),
  lastSelector: PropTypes.string.isRequired,
  enableLinks: PropTypes.bool,
  highlightSelected: PropTypes.bool,
  isDragging: PropTypes.bool.isRequired,
  level: PropTypes.number.isRequired,
  index: PropTypes.number,
  node: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    backColor: PropTypes.string,
    nodes: PropTypes.arrayOf(PropTypes.shape({})),
    state: PropTypes.string,
    id: PropTypes.string,
    nodeId: PropTypes.number
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectNode: PropTypes.func.isRequired,
  selectedId: PropTypes.string,
  target: PropTypes.shape({
    id: PropTypes.string,
    parentID: PropTypes.string
  })
};
export default TreeNode;